import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, ParamMap} from '@angular/router';
import {SortingArrayUtitlity} from 'app/services/utility.service'
import {Topic} from 'app/models/topic';
import {TopicService} from 'app/services/topic.service';
import {IAsset} from "app/models/asset.interface"
import {GoogleTagManagerService} from '../../services/google-tag-manager.service';
@Component({
    selector: 'app-topic',
    templateUrl: './topic.component.html',
    styleUrls: ['./topic.component.scss']
})
export class TopicComponent extends SortingArrayUtitlity implements OnInit {
    override asset: IAsset;
    back: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private topicService: TopicService,
        private topicGtmService: GoogleTagManagerService

    ) {
        super(topicGtmService);
    }

    //    onTileSort($vent) {
    //        this.onColumnSort($vent);
    //
    //    }

    private subscribeToRouteParam(): void {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id');
            if (id) {
                this.topicService.getById(id).subscribe(topic => {this.asset = topic;
                 this.asset.files.map(f => { f.containerId=this.asset.id; return f});
                 });
            }
        });
    }

    ngOnInit() {
        this.subscribeToRouteParam();
        this.back = location.pathname.includes('search') ? 'SEARCH' : 'HOME';
    }

    onSetThumbnail(file: any): void {
        if (this.asset && file) {
            (this.asset as any).thumbnailFileId = file.id;
            this.topicService.update(this.asset as any).subscribe();
        }
    }
}
